<template>
  <el-dialog
    :title="tips"
    :visible.sync="isShow"
    width="500px"
    append-to-body
  >
    <el-table
      :data="tableData"
      style="width: 100%;"
      max-height="250"
      size="small"
    >
      <el-table-column
        prop="name"
        :label="fileName"
      >
        <template slot-scope="scope">
          <el-link type="success" :href="scope.row.url" target="_blank">{{ scope.row.name }}</el-link>
        </template>
      </el-table-column>
      <el-table-column
        label=""
        width="100"
      >
        <template slot-scope="scope">
          <el-button type="danger" size="mini" @click="del(scope.$index)">{{ $t('GlobalSetObj.Delete') }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="upload">
      <UploadCmp
        ref="uploadRef"
        :drag="true"
        :multiple="true"
        :auto-upload="true"
        :limit="5"
        :tips="title"
        :is-check-file-type="true"
        :upload-text="uploadText"
        @change="onFileChange"
      />
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="isShow = false">{{ $t('GlobalSetObj.cancel') }}</el-button>
      <el-button type="primary" @click="onSubmit">{{ $t('GlobalSetObj.determine') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import i18n from '@/lang';
import UploadCmp from '@/views/claimsManagement/claimStatement/cmp/UploadCmp.vue';
import { apiSitePayableUpdateFile } from '@/api/finance/receivables';
import { apiSiteReceiptUpdateFile } from '@/api/finance/basicData';
const edit = i18n.t('GlobalSetObj.edit'); // 编辑
const document = i18n.t('base.document'); // 文件
const fileName = i18n.t('Resource.fileName'); // 文件名称
const title = i18n.t('basicData.UploadTheAttachmentFormat'); // 仅支持上传格式为bmp，jpg，png，gif，pdf，且大小在5M以内的附件

export default {
  components: {
    UploadCmp
  },

  data() {
    return {
      id: 0,
      isShow: false,
      tableData: [],
      fileArr: [],
      tips: '',
      fileName: '',
      title,
      type: '' // 1 应收账户 2 应付账户
    };
  },

  computed: {
    uploadText() {
      return this.$t('basicData.DragTheFileHereOrClickUpload');
    }
  },

  created() {
    this.tips = edit + document;
    this.fileName = fileName;
  },

  methods: {
    /**
     * 显示文件上传弹窗
     * @param id 账单id
     * @param arr 文件列表
     * @param type 1 应收账户 2 应付账户
     */
    open(id, arr, type) {
      console.log(id, 'id');
      this.isShow = true;
      this.id = id;
      this.fileArr = [];
      this.type = type;
      setTimeout(() => {
        this.$refs.uploadRef.clearFiles(); // 清空列表
      }, 100);
      this.tableData = arr.map((item, index) => {
        return {
          name: 'invoice' + (index + 1),
          url: item
        };
      });
    },

    onFileChange(arr) {
      this.fileArr = arr.map(item => {
        return item.url;
      });
    },

    del(index) {
      this.tableData.splice(index, 1);
    },

    getData() {
      const obj = {
        id: this.id,
        payFile: ''
      };
      const arr = this.tableData.map(item => item.url);
      // const arr2 = this.fileArr;
      obj.payFile = [...arr, ...this.fileArr].join(',');

      return obj;
    },

    onSubmit() {
      const data = this.getData();
      console.log(data, '附件');
      if (this.type === 1) {
        data.attachmentUrl = data.payFile;
        delete data.payFile;
      }
      const api = this.type === 1 ? apiSiteReceiptUpdateFile : apiSitePayableUpdateFile;
      api(data).then(res => {
        console.log(res);
        if (res.code === 200) {
          this.isShow = false;
          this.$emit('update');
          this.clear();
        }
      }).catch(err => {
        console.error(err);
      });
    },
    clear() {
      this.fileArr = [];
      this.id = '';
      this.type = '';
    }
  }

};
</script>

<style scoped>
.upload {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.upload >>> .el-upload-list {
  width: 450px;
}
</style>
